import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { CustomField } from "../../../types";
import { DefaultCustomField } from "../../../data";
import PortalService from '../../../services/portal.service';
import StateContext from "../../../context/State";
import { useAppSelector } from "../../../../../redux/hooks";
import { NewCustomFieldSetModal } from "../../../../Settings/ClientConnectFirmSettings/CustomFieldSets/newCustomFieldSet";
import { ClientConnectCustomFieldSet } from "../../../../Settings/ClientConnectFirmSettings/CustomFieldSets/types";
import { lddGlobalSessionInfo } from "../../../../navigationTypes";
import { getCustomFieldSet } from "../../../../Settings/ClientConnectFirmSettings/CustomFieldSets/customFieldSetFuncs";


export type AddCustomFieldsProps = {
    setCustomFields: (arg0: CustomField[]) => void;
    setCustomFieldSetNames: (arg0: string[]) => void;
    customFieldSetNames: string[];
    addRow?: boolean;
    setAddRow?: (arg0: boolean) => void;
    afterInit: boolean;
}

export type CheckedSetArray = {
    name: string;
    checked: boolean;
}

const AddCustomFields = (props: AddCustomFieldsProps) => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);
    const defaultCustomField: CustomField = { ...DefaultCustomField };
    const [fields, setFields] = useState<CustomField[]>([defaultCustomField]);
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const [show, setShow] = useState<boolean>(false)
    const [customFieldSets, setCustomFieldSets] = useState<ClientConnectCustomFieldSet[]>([])
    const [editFieldSet, setEditFieldSet] = useState<ClientConnectCustomFieldSet>(null);
    const [selectedCustomFieldSets, setSelectedCustomFieldSets] = useState<string[]>([])

    useEffect(() => { getSelectedCustomFieldSets(); }, [])
    useEffect(() => { getCustomFields(); }, [])
    useEffect(() => { getSetCustomFieldSet(); }, []);
    useEffect(() => { props.setCustomFields(fields.filter(f => f.name)); }, [fields])

    const getSetCustomFieldSet = async () => {
        const response = await getCustomFieldSet(sessionInfo.sid);
        if (response && response.length !== 0) {
            setCustomFieldSets(response);
        }
    }

    const handleClose = () => {
        getSetCustomFieldSet();
        setEditFieldSet(null)
        setShow(false);
    }

    const handleShow = async () => {
        setShow(true);
    };

    const addNewRow = () => {
        const emptyCustomField: CustomField = { ...DefaultCustomField };
        const prevFields = [...fields];
        prevFields.push(emptyCustomField);
        setFields(prevFields)
    }

    const handleFieldCleared = (index: number) => {
        const prevFields = [...fields];
        prevFields.splice(index, 1)
        setFields(prevFields)
    }

    const handleChange = (event, index: number) => {
        const prevFields = [...fields];
        prevFields[index].name = event.target.value;
        setFields(prevFields)
    }

    const handleSwitchToggle = (index: number, event) => {
        const prevFields = [...fields];
        prevFields[index].perClient = event.target.checked;
        setFields(prevFields)
    }

    const handleFieldSetSelected = (index, e) => {
        if (e.target.checked) {
            props.setCustomFieldSetNames([...props.customFieldSetNames, customFieldSets[index].fieldSetName])
            setSelectedCustomFieldSets([...selectedCustomFieldSets, customFieldSets[index].fieldSetName])
        } else {
            for (let i = 0; i < selectedCustomFieldSets.length; i++) {
                if (selectedCustomFieldSets.includes(customFieldSets[index].fieldSetName)) {
                    const prevSelectedCustomFieldSets = [...selectedCustomFieldSets];
                    prevSelectedCustomFieldSets.splice(i, 1);
                    setSelectedCustomFieldSets(prevSelectedCustomFieldSets)
                }
            }
            const prevCustomFieldSetNames = [...props.customFieldSetNames];
            for (let i = 0; i < prevCustomFieldSetNames.length; i++) {
                if (prevCustomFieldSetNames[i] === customFieldSets[index].fieldSetName) {
                    prevCustomFieldSetNames.splice(i, 1)
                }
            }
            props.setCustomFieldSetNames(prevCustomFieldSetNames)
        }
    }

    const getSelectedCustomFieldSets = async () => {
        if (state.portalId) {
            try {
                const response = await portalService.getSelectedCustomFieldSetsFromXML(state.portalId);
                setSelectedCustomFieldSets(response)
            } catch (e) {
                console.log('cant get selected custom field sets: ', e)
            }
        }
    }

    const getCustomFields = async () => {
        try {
            const response = await portalService.getClientPortalCustomFields(state.portalId);
            if (response.length !== 0) {
                const prevFields: CustomField[] = [];
                for (let i = 0; i < response.length; i++) {
                    prevFields.push({
                        value: response[i].Value,
                        type: response[i].Type,
                        name: response[i].Name
                    })
                }
                setFields(prevFields)
            }
        } catch (e) {
            console.log('could not get custom fields, ', e);
        }
    }

    return (
        <>
            {!props.afterInit &&
                <>
                    <h3>Include Intake Templates</h3>
                    <Table hover bordered>
                        <thead>
                            <tr>
                                <th>
                                    Template Name
                                </th>
                                <th>
                                    Include
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {customFieldSets.map((customFieldSet, index) => {
                                return (
                                    <tr key={'custom-field-row-' + index}>
                                        <td
                                            onClick={() => {
                                                setEditFieldSet(customFieldSet)
                                                handleShow()
                                            }}
                                        >
                                            {customFieldSet.fieldSetName}
                                        </td>
                                        <td>
                                            <Form.Check
                                                type='checkbox'
                                                onChange={(e) => handleFieldSetSelected(index, e)}
                                                checked={selectedCustomFieldSets.includes(customFieldSet.fieldSetName)}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </>
            }
            <br />
            <NewCustomFieldSetModal
                show={show}
                onHide={handleClose}
                editFieldSet={editFieldSet}
                fromSettings={false}
            />

            {props.afterInit ? null : <h3>Add Custom Fields</h3>}
            
            <Table className="table-input" bordered>
                <thead>
                    <tr>
                        <th>Field Name</th>
                        {/* <th>Per Client</th> */}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        fields.map((field, index) => {
                            return (
                                <tr key={field.id + '-custom-field-row-' + index}>
                                    <td>
                                        <Form.Control
                                            id={index.toString()}
                                            className="standard-form"
                                            onChange={e => handleChange(e, index)}
                                            value={field.name}
                                            placeholder="enter a field name.."
                                        />
                                    </td>
                                    {/* <td>
                                        <Form.Check // prettier-ignore
                                            type="switch"
                                            id="perClientSwitch"
                                            onChange={(event) => handleSwitchToggle(index, event)}
                                            checked={field.perClient}
                                            disabled={field.fromSet}
                                        />
                                    </td> */}
                                    <td>
                                        <Button
                                            variant="link"
                                            hidden={field.fromSet}
                                            onClick={() => handleFieldCleared(index)}
                                        >
                                            <i className="fa-regular fa-trash-can"></i>
                                        </Button>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={3}>
                            <Button
                                variant='link'
                                onClick={() => addNewRow()}
                            >
                                + Field
                            </Button>
                        </td>
                    </tr>
                </tfoot>
            </Table>
        </>
    )
}

export default AddCustomFields;
